export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: '韩漫' | '日漫' | '国漫';
  rating: number;
  status: '连载中' | '已完结';
  description: string;
  tags: string[];
  views: number;
  favorites: number;
  latestChapter: string;
  updatedAt: string;
  chapters: MangaChapter[];
}

export const hotRecommendations: Manga[] = [
  {
    id: 'manga-1',
    title: '修罗武神',
    author: '善良的蜜蜂',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20featuring%20a%20powerful%20martial%20artist%20in%20flowing%20red%20robes%20wielding%20a%20golden%20sword%20against%20a%20dramatic%20mountain%20backdrop%2C%20anime%20style%2C%20vibrant%20warm%20colors%2C%20epic%20composition%2C%20clean%20white%20background%20with%20subtle%20gradient&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: '国漫',
    rating: 9.6,
    status: '连载中',
    description: '一代修罗王转世重生，踏上逆天修行之路。在这弱肉强食的世界里，唯有不断变强才能守护珍视之人。',
    tags: ['热血', '玄幻', '修仙', '战斗'],
    views: 8560000,
    favorites: 245000,
    latestChapter: '第1287话 九天之上',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-1-1', title: '第1话 重生', number: 1, updatedAt: '2023-01-15' },
      { id: 'ch-1-2', title: '第2话 觉醒', number: 2, updatedAt: '2023-01-22' },
      { id: 'ch-1-1287', title: '第1287话 九天之上', number: 1287, updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 'manga-2',
    title: '我的野蛮王妃',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20showing%20an%20elegant%20woman%20in%20a%20stunning%20royal%20hanbok%20dress%20with%20intricate%20embroidery%2C%20standing%20in%20a%20traditional%20palace%20courtyard%20with%20cherry%20blossoms%2C%20soft%20romantic%20lighting%2C%20anime%20style&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: '韩漫',
    rating: 9.4,
    status: '连载中',
    description: '现代女孩意外穿越到古代王朝，成为野蛮王妃，与冷酷王爷展开一段啼笑皆非的爱情故事。',
    tags: ['恋爱', '穿越', '宫廷', '搞笑'],
    views: 7230000,
    favorites: 198000,
    latestChapter: '第156话 王妃的秘密',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-2-1', title: '第1话 穿越', number: 1, updatedAt: '2024-03-10' },
      { id: 'ch-2-156', title: '第156话 王妃的秘密', number: 156, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: 'manga-3',
    title: '鬼灭之刃外传',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20cover%20featuring%20a%20young%20demon%20slayer%20with%20a%20nichirin%20blade%20in%20a%20dynamic%20action%20pose%2C%20dark%20atmospheric%20background%20with%20floating%20cherry%20blossom%20petals%2C%20anime%20style%2C%20dramatic%20lighting%20with%20warm%20golden%20accents&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: '日漫',
    rating: 9.8,
    status: '已完结',
    description: '在人与鬼共存的世界中，少年踏上斩鬼之旅。这是一段关于勇气、羁绊与成长的传奇故事。',
    tags: ['热血', '战斗', '奇幻', '冒险'],
    views: 12200000,
    favorites: 356000,
    latestChapter: '第205话 最终话',
    updatedAt: '2025-12-20',
    chapters: [
      { id: 'ch-3-1', title: '第1话 残酷', number: 1, updatedAt: '2020-05-10' },
      { id: 'ch-3-205', title: '第205话 最终话', number: 205, updatedAt: '2025-12-20' },
    ],
  },
  {
    id: 'manga-4',
    title: '绝世神医',
    author: '风行烈',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20of%20a%20handsome%20young%20doctor%20in%20flowing%20white%20traditional%20robes%20holding%20a%20glowing%20golden%20acupuncture%20needle%2C%20ancient%20Chinese%20medicine%20theme%2C%20misty%20mountain%20and%20bamboo%20forest%20background%2C%20elegant%20anime%20art%20style&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: '国漫',
    rating: 9.3,
    status: '连载中',
    description: '一代医圣重生为落魄世家子弟，凭借绝世医术逆天改命，且看他如何以医术震天下。',
    tags: ['玄幻', '医术', '逆袭', '热血'],
    views: 5120000,
    favorites: 167000,
    latestChapter: '第892话 妙手回春',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-4-1', title: '第1话 重生', number: 1, updatedAt: '2023-06-20' },
      { id: 'ch-4-892', title: '第892话 妙手回春', number: 892, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: 'manga-5',
    title: '社内恋爱',
    author: '朴智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20office%20romance%20manhwa%20cover%20depicting%20a%20stylish%20modern%20couple%20in%20business%20attire%20sharing%20a%20tender%20moment%20in%20a%20sleek%20office%20setting%20with%20city%20skyline%20through%20windows%2C%20soft%20warm%20lighting%2C%20romantic%20anime%20style&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: '韩漫',
    rating: 9.1,
    status: '连载中',
    description: '霸道总裁与职场新人的办公室秘密恋情。白天是上下级，夜晚是恋人，这段关系究竟能走多远？',
    tags: ['恋爱', '职场', '总裁', '甜宠'],
    views: 6450000,
    favorites: 189000,
    latestChapter: '第98话 公开关系',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-5-1', title: '第1话 入职', number: 1, updatedAt: '2025-01-10' },
      { id: 'ch-5-98', title: '第98话 公开关系', number: 98, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: 'manga-6',
    title: '咒术回战：零',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20dark%20fantasy%20manga%20cover%20featuring%20a%20sorcerer%20with%20glowing%20cursed%20energy%20surrounding%20him%2C%20intense%20expression%2C%20dark%20urban%20Tokyo%20backdrop%20with%20supernatural%20elements%2C%20anime%20style%2C%20dramatic%20composition&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: '日漫',
    rating: 9.5,
    status: '连载中',
    description: '咒术高专的学生们为保护人类免受诅咒侵害而战斗。在这场无尽的战斗中，每个人都背负着自己的命运。',
    tags: ['奇幻', '战斗', '暗黑', '校园'],
    views: 9780000,
    favorites: 289000,
    latestChapter: '第271话 终焉之始',
    updatedAt: '2026-07-30',
    chapters: [
      { id: 'ch-6-1', title: '第1话 两面宿傩', number: 1, updatedAt: '2021-03-15' },
      { id: 'ch-6-271', title: '第271话 终焉之始', number: 271, updatedAt: '2026-07-30' },
    ],
  },
  {
    id: 'manga-7',
    title: '斗罗大陆V',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%20showing%20a%20young%20warrior%20with%20glowing%20martial%20spirit%20rings%20surrounding%20him%2C%20epic%20battle%20pose%2C%20mythical%20beast%20companion%20behind%2C%20ancient%20Chinese%20landscape%20with%20floating%20islands%2C%20vibrant%20anime%20style&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: '国漫',
    rating: 9.7,
    status: '连载中',
    description: '唐三转世重生，带着前世的记忆与唐门绝学，在这个全新的斗罗世界重新踏上成神之路。',
    tags: ['热血', '玄幻', '冒险', '战斗'],
    views: 15800000,
    favorites: 420000,
    latestChapter: '第567话 海神降临',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-7-1', title: '第1话 重生唐三', number: 1, updatedAt: '2022-08-10' },
      { id: 'ch-7-567', title: '第567话 海神降临', number: 567, updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 'manga-8',
    title: '女神降临',
    author: '猫咪',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20beauty%20transformation%20manhwa%20cover%20showing%20a%20stunningly%20beautiful%20young%20woman%20with%20perfect%20makeup%20looking%20into%20a%20vanity%20mirror%2C%20glamorous%20bedroom%20background%20with%20cosmetics%2C%20soft%20dreamy%20lighting%2C%20romantic%20anime%20art%20style&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: '韩漫',
    rating: 9.2,
    status: '已完结',
    description: '相貌平平的女孩通过化妆术蜕变为校园女神，却不得不隐藏真实的自己。两个男神同时爱上她，她该如何选择？',
    tags: ['恋爱', '校园', '美妆', '甜宠'],
    views: 8920000,
    favorites: 267000,
    latestChapter: '第234话 终章',
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch-8-1', title: '第1话 素颜', number: 1, updatedAt: '2023-04-20' },
      { id: 'ch-8-234', title: '第234话 终章', number: 234, updatedAt: '2026-06-15' },
    ],
  },
];

export const rankingManga: Manga[] = [
  {
    id: 'manga-r1',
    title: '遮天',
    author: '辰东',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manhua%20cover%20depicting%20an%20immortal%20cultivator%20in%20flowing%20celestial%20robes%20standing%20on%20a%20mountain%20peak%20with%20stars%20and%20galaxies%20in%20the%20background%2C%20epic%20scale%2C%20anime%20style%2C%20golden%20divine%20light&width=400&height=560&seq=manga-cover-r01&orientation=portrait',
    category: '国漫',
    rating: 9.9,
    status: '连载中',
    description: '冰冷与黑暗并存的宇宙深处，九具庞大的龙尸拉着一口青铜古棺，亘古长存。登天路，踏歌行，弹指遮天。',
    tags: ['玄幻', '修仙', '热血', '史诗'],
    views: 25600000,
    favorites: 680000,
    latestChapter: '第1890话 遮天大帝',
    updatedAt: '2026-08-03',
    chapters: [],
  },
  {
    id: 'manga-r2',
    title: '我独自升级',
    author: 'Chugong',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%20showing%20a%20powerful%20hunter%20with%20dark%20armor%20and%20glowing%20purple%20energy%2C%20standing%20in%20a%20dungeon%20gate%2C%20shadow%20army%20behind%20him%2C%20epic%20dark%20fantasy%20style%2C%20intense%20atmosphere&width=400&height=560&seq=manga-cover-r02&orientation=portrait',
    category: '韩漫',
    rating: 9.8,
    status: '已完结',
    description: '最弱E级猎人成振宇在经历了生死考验后，获得了独一无二的升级系统，踏上了成为最强猎人的征途。',
    tags: ['热血', '奇幻', '战斗', '升级'],
    views: 32100000,
    favorites: 890000,
    latestChapter: '第179话 终章',
    updatedAt: '2026-03-20',
    chapters: [],
  },
  {
    id: 'manga-r3',
    title: '海贼王',
    author: '尾田荣一郎',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20pirate%20adventure%20manga%20cover%20featuring%20a%20young%20pirate%20captain%20with%20a%20straw%20hat%20sailing%20on%20a%20ship%20with%20his%20crew%2C%20vast%20ocean%20and%20blue%20sky%20background%2C%20adventurous%20anime%20style%2C%20vibrant%20colors&width=400&height=560&seq=manga-cover-r03&orientation=portrait',
    category: '日漫',
    rating: 9.9,
    status: '连载中',
    description: '拥有财富、名声、权力的海贼王哥尔·D·罗杰，在临刑前的一句话，让人们趋之若鹜地奔向大海。',
    tags: ['冒险', '热血', '友情', '奇幻'],
    views: 45600000,
    favorites: 1200000,
    latestChapter: '第1120话 最终岛',
    updatedAt: '2026-08-04',
    chapters: [],
  },
  {
    id: 'manga-r4',
    title: '完美世界',
    author: '辰东',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%20showing%20a%20young%20boy%20with%20divine%20power%20in%20a%20primitive%20ancient%20world%2C%20mythical%20creatures%20and%20giant%20bones%20in%20the%20landscape%2C%20epic%20adventure%20theme%2C%20anime%20style%2C%20warm%20earthy%20tones&width=400&height=560&seq=manga-cover-r04&orientation=portrait',
    category: '国漫',
    rating: 9.7,
    status: '连载中',
    description: '一粒尘可填海，一根草斩尽日月星辰。大荒中走出的少年，以万物为兵，以天地为炉，铸就不朽传说。',
    tags: ['玄幻', '热血', '战斗', '冒险'],
    views: 18900000,
    favorites: 520000,
    latestChapter: '第1567话 至尊骨',
    updatedAt: '2026-08-02',
    chapters: [],
  },
  {
    id: 'manga-r5',
    title: '全知读者视角',
    author: 'sing N song',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20apocalyptic%20manhwa%20cover%20depicting%20an%20ordinary%20office%20worker%20transformed%20into%20a%20protagonist%20in%20a%20destroyed%20city%20with%20monsters%2C%20holding%20a%20glowing%20book%2C%20dramatic%20survival%20theme%2C%20anime%20style&width=400&height=560&seq=manga-cover-r05&orientation=portrait',
    category: '韩漫',
    rating: 9.6,
    status: '连载中',
    description: '某天世界变成了自己读过的小说，作为唯一的读者，金独子开始了在这个末日世界中的生存冒险。',
    tags: ['奇幻', '末世', '冒险', '智斗'],
    views: 14300000,
    favorites: 410000,
    latestChapter: '第210话 最终章预告',
    updatedAt: '2026-08-01',
    chapters: [],
  },
  {
    id: 'manga-r6',
    title: '进击的巨人',
    author: '谏山创',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20dark%20fantasy%20manga%20cover%20showing%20a%20soldier%20with%20vertical%20maneuvering%20equipment%20flying%20towards%20a%20massive%20titan%2C%20colossal%20walls%20in%20the%20background%2C%20apocalyptic%20atmosphere%2C%20intense%20dramatic%20anime%20style&width=400&height=560&seq=manga-cover-r06&orientation=portrait',
    category: '日漫',
    rating: 9.8,
    status: '已完结',
    description: '人类为了抵御巨人的威胁，筑起了巨大的城墙。少年艾伦亲眼目睹母亲被巨人吞噬，誓要将所有巨人驱逐出去。',
    tags: ['暗黑', '战斗', '末世', '悬疑'],
    views: 28900000,
    favorites: 750000,
    latestChapter: '第139话 终话',
    updatedAt: '2024-11-05',
    chapters: [],
  },
  {
    id: 'manga-r7',
    title: '元尊',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manhua%20cover%20featuring%20a%20young%20prince%20in%20magnificent%20golden%20armor%20with%20a%20dragon%20spirit%20behind%20him%2C%20imperial%20palace%20background%2C%20regal%20and%20powerful%20atmosphere%2C%20anime%20style%2C%20warm%20golden%20tones&width=400&height=560&seq=manga-cover-r07&orientation=portrait',
    category: '国漫',
    rating: 9.4,
    status: '连载中',
    description: '周元身负圣龙气运，却因怨龙之毒而经脉尽断。且看他如何一步步解开谜题，重振大周王朝的荣耀。',
    tags: ['玄幻', '修仙', '热血', '逆袭'],
    views: 11200000,
    favorites: 340000,
    latestChapter: '第1023话 圣龙觉醒',
    updatedAt: '2026-07-29',
    chapters: [],
  },
  {
    id: 'manga-r8',
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20comedy%20spy%20manga%20cover%20showing%20a%20family%20of%20three%20a%20spy%20father%20an%20assassin%20mother%20and%20a%20telepathic%20daughter%20posing%20together%2C%20whimsical%20and%20heartwarming%20style%2C%20pastel%20colors%2C%20charming%20anime%20art&width=400&height=560&seq=manga-cover-r08&orientation=portrait',
    category: '日漫',
    rating: 9.7,
    status: '连载中',
    description: '为了执行任务，西国间谍「黄昏」必须组建一个临时家庭。然而，他的「女儿」是超能力者，「妻子」是杀手。',
    tags: ['搞笑', '日常', '温馨', '间谍'],
    views: 16700000,
    favorites: 480000,
    latestChapter: '第98话 家庭旅行',
    updatedAt: '2026-07-28',
    chapters: [],
  },
];

export const latestUpdates: Manga[] = [
  {
    id: 'manga-l1',
    title: '武炼巅峰',
    author: '莫默',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20manhua%20cover%20showing%20a%20warrior%20breaking%20through%20a%20mountain%20with%20his%20fist%2C%20intense%20training%20montage%20vibe%2C%20dramatic%20sky%20and%20energy%20effects%2C%20anime%20style%2C%20warm%20golden%20light&width=400&height=560&seq=manga-cover-l01&orientation=portrait',
    category: '国漫',
    rating: 9.0,
    status: '连载中',
    description: '杨开从一个扫地小厮开始，凭借坚韧不拔的意志，一步步攀上武道巅峰的传奇故事。',
    tags: ['热血', '玄幻', '战斗', '成长'],
    views: 3400000,
    favorites: 98000,
    latestChapter: '第2105话 巅峰之战',
    updatedAt: '2026-08-04',
    chapters: [],
  },
  {
    id: 'manga-l2',
    title: '某天成为公主',
    author: 'Plutus',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20romance%20manhwa%20cover%20showing%20a%20beautiful%20young%20princess%20in%20a%20sparkling%20pink%20ballgown%20in%20a%20grand%20royal%20palace%20ballroom%2C%20romantic%20atmosphere%20with%20floating%20magic%20sparkles%2C%20anime%20style&width=400&height=560&seq=manga-cover-l02&orientation=portrait',
    category: '韩漫',
    rating: 9.3,
    status: '连载中',
    description: '穿越成小说中的悲情公主，她决定改变命运。可那个冷血的父皇，怎么越来越温柔了？',
    tags: ['恋爱', '穿越', '宫廷', '甜宠'],
    views: 5670000,
    favorites: 178000,
    latestChapter: '第125话 父皇的温柔',
    updatedAt: '2026-08-03',
    chapters: [],
  },
  {
    id: 'manga-l3',
    title: '电锯人',
    author: '藤本树',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20dark%20action%20manga%20cover%20featuring%20a%20young%20man%20with%20chainsaw%20blades%20protruding%20from%20his%20head%20and%20arms%2C%20urban%20night%20setting%20with%20neon%20lights%2C%20chaotic%20and%20raw%20energy%2C%20anime%20style%2C%20bold%20red%20accents&width=400&height=560&seq=manga-cover-l03&orientation=portrait',
    category: '日漫',
    rating: 9.5,
    status: '连载中',
    description: '为了偿还父亲留下的巨额债务，少年淀治与恶魔啵奇塔融合，成为了可以变身电锯的恶魔猎人。',
    tags: ['暗黑', '战斗', '奇幻', '热血'],
    views: 8900000,
    favorites: 256000,
    latestChapter: '第178话 链锯轰鸣',
    updatedAt: '2026-08-02',
    chapters: [],
  },
  {
    id: 'manga-l4',
    title: '第一序列',
    author: '会说话的肘子',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20post-apocalyptic%20manhua%20cover%20showing%20a%20survivor%20in%20wasteland%20gear%20with%20a%20high-tech%20weapon%2C%20ruined%20cityscape%20and%20desert%20background%2C%20survival%20adventure%20theme%2C%20anime%20style%2C%20warm%20desert%20tones&width=400&height=560&seq=manga-cover-l04&orientation=portrait',
    category: '国漫',
    rating: 9.2,
    status: '连载中',
    description: '核战废土之上，人类文明倒退。任小粟凭借体内神秘宫殿，在废土中崛起，守护最后的人类希望。',
    tags: ['末世', '科幻', '热血', '冒险'],
    views: 4230000,
    favorites: 134000,
    latestChapter: '第678话 序列觉醒',
    updatedAt: '2026-08-04',
    chapters: [],
  },
  {
    id: 'manga-l5',
    title: '恶役千金',
    author: 'SORAJIMA',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20villainess%20reincarnation%20manhwa%20cover%20showing%20a%20noblewoman%20with%20an%20elegant%20yet%20mischievous%20smile%20in%20a%20luxurious%20Victorian%20dress%2C%20grand%20mansion%20interior%2C%20dramatic%20lighting%2C%20anime%20style&width=400&height=560&seq=manga-cover-l05&orientation=portrait',
    category: '韩漫',
    rating: 9.1,
    status: '连载中',
    description: '转生为乙女游戏中的恶役千金，为了不被流放或处刑，她开始改写自己的命运轨迹。',
    tags: ['穿越', '恋爱', '宫廷', '搞笑'],
    views: 6780000,
    favorites: 198000,
    latestChapter: '第89话 命运之舞',
    updatedAt: '2026-08-01',
    chapters: [],
  },
  {
    id: 'manga-l6',
    title: '葬送的芙莉莲',
    author: '山田钟人',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20fantasy%20manga%20cover%20depicting%20an%20elven%20mage%20with%20long%20silver%20hair%20walking%20through%20a%20peaceful%20flower%20field%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20beautiful%20scenery%2C%20anime%20style%2C%20soft%20pastel%20colors&width=400&height=560&seq=manga-cover-l06&orientation=portrait',
    category: '日漫',
    rating: 9.8,
    status: '连载中',
    description: '勇者一行人打倒魔王后，长生种的精灵魔法使芙莉莲开始了理解人类情感的旅程。',
    tags: ['奇幻', '治愈', '冒险', '哲理'],
    views: 10200000,
    favorites: 320000,
    latestChapter: '第135话 百年之后',
    updatedAt: '2026-07-31',
    chapters: [],
  },
  {
    id: 'manga-l7',
    title: '仙王的日常生活',
    author: '枯玄',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20school%20life%20fantasy%20manhua%20cover%20showing%20a%20teenage%20boy%20with%20immense%20hidden%20power%20sitting%20in%20a%20classroom%2C%20normal%20school%20setting%20with%20subtle%20magical%20effects%2C%20comedic%20vibe%2C%20anime%20style&width=400&height=560&seq=manga-cover-l07&orientation=portrait',
    category: '国漫',
    rating: 9.0,
    status: '连载中',
    description: '修真大佬王令只想安静地上学，可总有各种麻烦找上门来。低调做人，高调修仙，这就是仙王的日常。',
    tags: ['搞笑', '校园', '修仙', '日常'],
    views: 3890000,
    favorites: 112000,
    latestChapter: '第456话 低调修仙',
    updatedAt: '2026-08-03',
    chapters: [],
  },
  {
    id: 'manga-l8',
    title: '剑尊归来',
    author: 'Redice Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20martial%20arts%20manhwa%20cover%20showing%20an%20elderly%20sword%20master%20reborn%20as%20a%20young%20man%20holding%20a%20magnificent%20sword%2C%20ancient%20Korean%20landscape%20with%20mountains%20and%20waterfalls%2C%20powerful%20and%20dignified%2C%20anime%20style&width=400&height=560&seq=manga-cover-l08&orientation=portrait',
    category: '韩漫',
    rating: 9.4,
    status: '连载中',
    description: '天下第一剑尊在生命尽头选择了重生，回到少年时代。这一次，他要用手中之剑守护所有在乎的人。',
    tags: ['热血', '武侠', '重生', '战斗'],
    views: 7560000,
    favorites: 234000,
    latestChapter: '第167话 一剑破天',
    updatedAt: '2026-08-02',
    chapters: [],
  },
];

export const categories = [
  {
    id: 'cat-kr',
    name: '韩漫',
    icon: 'ri-kakao-talk-fill',
    description: '韩国漫画精选',
    count: 3280,
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20collage%20of%20Korean%20manhwa%20art%20featuring%20romance%20and%20fantasy%20themes%2C%20elegant%20characters%2C%20soft%20dreamy%20color%20palette%2C%20Korean%20webtoon%20style%2C%20warm%20lighting%2C%20artistic%20composition&width=800&height=400&seq=manga-cat-kr&orientation=landscape',
  },
  {
    id: 'cat-jp',
    name: '日漫',
    icon: 'ri-sun-fill',
    description: '日本漫画精选',
    count: 5620,
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20collage%20of%20Japanese%20manga%20art%20showing%20action%20scenes%20and%20character%20portraits%2C%20diverse%20genres%20from%20shonen%20to%20slice%20of%20life%2C%20classic%20manga%20style%2C%20vibrant%20and%20expressive&width=800&height=400&seq=manga-cat-jp&orientation=landscape',
  },
  {
    id: 'cat-cn',
    name: '国漫',
    icon: 'ri-flag-fill',
    description: '中国漫画精选',
    count: 4560,
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20collage%20of%20Chinese%20manhua%20art%20featuring%20cultivation%20and%20martial%20arts%20themes%2C%20traditional%20Chinese%20aesthetics%2C%20flowing%20robes%20and%20mythical%20creatures%2C%20dramatic%20and%20epic%20atmosphere&width=800&height=400&seq=manga-cat-cn&orientation=landscape',
  },
];